export default {
  GAEvent(category, action, label) {
    window.tracking.GAEvent(category, action, label);
  },

  splitString(string, separator) {
    return string.split(separator);
  },

  SwitchLabelSide(typeID, side, format) {
    const data = {
      typeID: [11],
      format: [5]
    };

    if (data.typeID.includes(typeID) && format == '2') {
      if (side === 'front') {
        return 'outside';
      } else if (side === 'back') {
        return 'inside';
      }
    }

    if (data.format.includes(format)) {
      if (side === 'front') {
        return 'top';
      } else if (side === 'back') {
        return 'bottom';
      }
    }

    return side;
  },

  favoriteBundleDesigns(designs, favorite) {
    const result = designs.map(item => {
      item.isFavorite = false;
      if (favorite.length && favorite.includes(item.designID)) {
        item.isFavorite = true;
      }

      return item;
    });
    return result;
  },

  removeEmpty(obj) {
    $.each(obj, (key, value) => {
      if (value === '' || value === null) {
        delete obj[key];
      } else if (Object.prototype.toString.call(value) === '[object Object]') {
        filter(value);
      }
    });
  },

  shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  },

  mapOrder(array, order, key) {
    array.sort((a, b) => {
      var A = a[key],
        B = b[key];

      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });

    return array;
  },

  ucWords(string) {
    return string.toLowerCase().replace(/\b[a-z]/g, function(letter) {
      return letter.toUpperCase();
    });
  }
};

const encodeQueryData = data => {
  const ret = [];
  for (let d in data)
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
};

const remove_non_ascii = str => {
  if (str === null || str === '') return false;
  else str = str.toString();

  return str.replace(/[^\x20-\x7E]/g, '');
};

const localTime = () => {
  // Get local time as ISO string with offset at the end
  const now = new Date();
  const tzo = -now.getTimezoneOffset();
  const dif = tzo >= 0 ? '+' : '-';
  const pad = function(num) {
    const norm = Math.abs(Math.floor(num));
    return (norm < 10 ? '0' : '') + norm;
  };
  return (
    now.getFullYear() +
    '-' +
    pad(now.getMonth() + 1) +
    '-' +
    pad(now.getDate()) +
    'T' +
    pad(now.getHours()) +
    ':' +
    pad(now.getMinutes()) +
    ':' +
    pad(now.getSeconds()) +
    '.' +
    pad(now.getMilliseconds()) +
    dif +
    pad(tzo / 60) +
    ':' +
    pad(tzo % 60)
  );
};

const debounce = (func, wait = 10, immediate = true) => {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export { remove_non_ascii, encodeQueryData, localTime, debounce };
